module.exports = __webpack_public_path__ + "static/media/long-term.a5dcdf9e.webp";